import { AutocompleteInput, ReferenceInput, required } from "react-admin";
import React, { useEffect } from "react";
import { useField } from "react-final-form";

interface ISelectedSchoolInput {
  schoolIdSelected: number;
  disabled?: boolean;
}

const SelectedSchoolInput = ({
  schoolIdSelected,
  disabled,
}: ISelectedSchoolInput) => {
  const schoolIdField = useField("schoolId");

  useEffect(() => {
    schoolIdField.input.onChange(schoolIdSelected);
  }, [schoolIdSelected]);

  return (
    <ReferenceInput
      label="School"
      source="schoolId"
      reference="schools"
      validate={required()}
      filterToQuery={(searchText: any) => {
        if (searchText !== "") return { search: searchText };
      }}
      disabled={disabled}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  );
};

export default SelectedSchoolInput;
